// extracted by mini-css-extract-plugin
export default {"DigitClock":"DigitClock_DigitClock__SsZop"};